import script from "./HomeRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeRoute.vue?vue&type=script&setup=true&lang=js"

import "./HomeRoute.vue?vue&type=style&index=0&id=ff70667c&scoped=true&lang=sass"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff70667c"]])

export default __exports__